import React, { Component } from 'react'
import '../styles/VeryBadNight.css'
import Navbar from './Navbar'
import BookingContainer from './BookingContainer'
import Footer from './Footer'
import PopInVBNCustom from './PopInVBNCustom'
import VBNPicture1 from '../images/Themes/VBN/vbn-picture-1.jpg'
import VBNPicture1Mobile from '../images/Themes/VBN/mobile-verybadnight-cover.jpg'
import VBNPicture2 from '../images/Themes/VBN/vbn-picture-2.jpg'
import VBNPicture3 from '../images/Themes/VBN/vbn-picture-3.jpg'
import VBNPicture4 from '../images/Themes/VBN/vbn-picture-4.jpg'
import VBNPicture5 from '../images/Themes/VBN/vbn-picture-5.jpg'
import TombeauPicture1 from '../images/Themes/Tombeau/Tombeau-picture-1.jpg'
import LACover from '../images/Themes/LA/la-cover.jpg'
import VBNIcon from '../images/Themes/icon-vbn.png'
import AbattoirPicture1 from '../images/Themes/Abattoir/abattoir-picture-1.jpg'
import YakuzaPicture1 from '../images/Themes/Yakuza/yakuza-picture-1.jpg'
import MagnifierIcon from '../images/Themes/magnifier-icon.png'
import GlobeIcon from '../images/Themes/globe-icon.png'
import StarIcon from '../images/Themes/star-icon.png'
import PlayerIcon from '../images/Themes/player-icon.png'
import MonkeyEmoji from '../images/Themes/VBN/monkey-emoji.png'
import RelaxedUnicorn from '../images/Themes/VBN/relaxed-unicorn.png'
import { Link } from 'react-router-dom'
import ReactPlayer from 'react-player'
import { injectIntl, defineMessages } from 'react-intl'
import Helmet from 'react-helmet'

const removeTransition = (element) => {
  element.classList.remove("site-transition--visible")
}

const BackgroundUrl = `url(${VBNPicture1})`;
const BackgroundUrlMobile = `url(${VBNPicture1Mobile})`;

class VeryBadNight extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isTop: true,
      showPopIn: false,
      videoPlaying: false,
      smallVideoPlaying: false
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop) {
          this.setState({ isTop })
      }
    })

    const glitchTransition = document.getElementById("site-transition")
    window.setTimeout(() => {
      glitchTransition.classList.add("site-transition--visible")
      window.setTimeout(() => {
        removeTransition(glitchTransition)
      }, 500)
    }, 10)
  }

  togglePopIn = () => {
    this.setState({ showPopIn: !this.state.showPopIn })
  }

  render() {
    const {intl:{formatMessage}} = this.props
    return (
      <div className="theme lost-asylum">
        <Helmet>
          <title>Very Bad Night : l'escape game lendemain de soirée à Paris !</title>
          <meta name="description" content={formatMessage(messages.VBNMeta)} />
			<meta property="og:type" content="website"/>
			<meta property="og:url" content="https://www.one-hour.fr/very-bad-night/"/>
			<meta property="og:title" content="Very Bad Night : l'escape game lendemain de soirée à Paris !"/>
			<meta property="og:description" content="VVery Bad Night c'est l'escape game fun sans prise de tête à Paris ! En équipe de 2 à 6 joueurs, l'idéal pour un anniversaire, EVG ou EVJF ou simplement pour un escape game complètement déjanté !"/>
			<meta property="og:image" content="https://www.one-hour.fr/static/media/pressen-3.jpg"/>
			<meta property="twitter:card" content="summary_large_image"/>
			<meta property="twitter:url" content="https://www.one-hour.fr/very-bad-night/"/>
			<meta property="twitter:title" content="Very Bad Night : l'escape game lendemain de soirée à Paris !"/>
			<meta property="twitter:description" content="Very Bad Night c'est l'escape game fun sans prise de tête à Paris ! En équipe de 2 à 6 joueurs, l'idéal pour un anniversaire, EVG ou EVJF ou simplement pour un escape game complètement déjanté !"/>
			<meta property="twitter:image" content="https://www.one-hour.fr/static/media/pressen-3.jpg"/>
			<link rel="apple-touch-icon" href="https://www.one-hour.fr/static/media/apple-touch-icon.png" />
			<html lang="fr" />
        </Helmet>
        <div className="theme-hero">
          <Navbar
            isTop={this.state.isTop}
            handleLang={(lang) => this.props.handleLang(lang)}
            lang={this.props.lang}/>
          <div
            className="theme-hero-cover theme-hero-cover--vbn theme-d-background"
            style={{ '--background-url': BackgroundUrl, '--background-url-mobile':BackgroundUrlMobile }}>
            {
              this.state.videoPlaying
              ?
                <ReactPlayer
                  url='https://www.youtube.com/watch?v=YhX07IK3dkk'
                  playing
                  width="100%"
                  height="100%"
                  controls={false}
                  onEnded={() => this.setState({ videoPlaying: false })}
                  config={
                    {
                      youtube: {
                        controls: 0,
                        showInfo: 0
                      }
                    }
                  } />
                : null
            }
          </div>
          {
            !this.state.videoPlaying
            ?
              <div className="theme-title">
                <div className="theme-logo" style={{ backgroundImage: `url(${VBNIcon})`}}></div>
                <div className="title">{formatMessage(messages.VBN)}</div>
                <div className="play-video-button" onClick={() => this.setState({ videoPlaying: true })}>
                  <span>{formatMessage(messages.playVideo)}</span>
                  <span className="play-video-icon">
                    <i className="fas fa-play"></i>
                  </span>
                </div>
              </div>
            : null
          }
          {
            !this.state.videoPlaying
            ?
              <div className="theme-infobar">
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.genre)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.genreInfo)}</div>
                  <div className="theme-infobar-icon"><img src={MagnifierIcon} alt="" /></div>
                </div>
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.difficulty)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.difficultyInfo)}</div>
                  <div className="theme-infobar-icon"><img src={StarIcon} alt="" /></div>
                </div>
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.players)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.playersInfo)}</div>
                  <div className="theme-infobar-icon"><img src={PlayerIcon} alt="" /></div>
                </div>
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.language)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.languageInfo)}</div>
                  <div className="theme-infobar-icon"><img src={GlobeIcon} alt="" /></div>
                </div>
              </div>
            : null
          }
        </div>
        <div className="theme-presentation-text-wrapper theme-presentation-text-wrapper--vbn">
          <div className="theme-presentation-text theme-presentation-text--vbn">
		    <h1>{formatMessage(messages.titreh1)}</h1>
            <p>{formatMessage(messages.presentationText1)}</p>
            <p>{formatMessage(messages.presentationText2)}</p>
            <div className="theme-presentation-disclaimer">
              <img alt="" src={MonkeyEmoji} />
              <span>{formatMessage(messages.disclaimer)}</span>
            </div>
          </div>
        </div>
        <div className="theme-customization-option">
          <img id="relaxed-unicorn" src={RelaxedUnicorn} alt="relaxed unicorn"/>
          <h3>{formatMessage(messages.customizationOption)}</h3>
          <h4>{formatMessage(messages.customizationOptionText1)}</h4>
          <p>{formatMessage(messages.customizationOptionText2)}</p>
          <p onClick={this.togglePopIn.bind(this)}>{formatMessage(messages.learnMore)} <span className="question-mark">?</span></p>
        </div>
        <div className="theme-gallery-container">
          <span className="theme-gallery-label">{formatMessage(messages.gallery)}</span>
          <div className="theme-gallery">
            <div className="theme-gallery-testimonial">
              <p className="theme-gallery-testimonial-comment">{formatMessage(messages.testimonalComment)}</p>
              <p className="theme-gallery-testimonial-author">
                <span>{formatMessage(messages.testimonalAuthor)}</span>
                <i className="fab fa-tripadvisor"></i>
              </p>
            </div>
            <div
              className="theme-gallery-image theme-gallery-video theme-gallery-video--vbn"
              style={{backgroundImage: `url(${VBNPicture3})`}}
              >
              {
                this.state.smallVideoPlaying
                ?
                  <ReactPlayer
                    url='https://www.youtube.com/watch?v=YhX07IK3dkk'
                    playing
                    width="100%"
                    height="100%"
                    controls={false}
                    onEnded={() => this.setState({ smallVideoPlaying: false })}
                    config={
                      {
                        youtube: {
                          controls: 0,
                          showInfo: 0
                        }
                      }
                    } />
                : <div style={{ width: "100%", height: "100%", position: "relative"}}>
                    <span
                      className="theme-gallery-play-button"
                      onClick={() => this.setState({ smallVideoPlaying: true })}
                      >►</span>
                  </div>
              }
            </div>
            <div
              style={{backgroundImage: `url(${VBNPicture2})`}}
              className="theme-gallery-image theme-gallery-picture-1"></div>
            <div
              style={{backgroundImage: `url(${VBNPicture4})`}}
              className="theme-gallery-image theme-gallery-picture-2"></div>
            <div
              style={{backgroundImage: `url(${VBNPicture5})`}}
              className="theme-gallery-image theme-gallery-picture-3"></div>
          </div>
        </div>
        <BookingContainer
		  theme="vbn"
          lang={this.props.lang}
          expiration={() => this.props.handleExpiration()}
        />
		<div className="theme-content">
		    <p>
		    L’âge minimum pour participer à une session chez One Hour est de 14 ans.
		    </p>
		    <h2>Escape Game fun à Paris</h2>
			<p>Very Bad Night prend à contrepied les escape game qui se prennent un peu trop au sérieux ! L’objectif : le fun ! Votre mission ne sera certe pas de sauver le monde d’une attaque de zombies, ni d’arrêter des extraterrestres mais de vous sauvez vous même de votre pire gueule de bois !</p>
			<p>Cet <strong>escape game fun situé à Paris</strong> vous embarque dans des défis tous plus fous les uns que les autres, idéal pour un anniversaire, un enterrement de vie de garçon, un <a href="https://www.one-hour.fr/enterrement-de-vie-de-jeune-fille-escape-game/">Enterrement de vie de jeune fille escape game</a> ou plus simplement pour faire un escape game sans trop se prendre la tête ! Very Bad Night a gagné <strong>l’award du meilleur scénario escape game 2017</strong>.
			<h2>Un escape game en constante évolution</h2>
			<p>Very Bad Night, sortie en 2016, est la deuxième salle de One Hour. Afin de proposer une expérience à la hauteur des escape game nouvelles générations, Very Bad Night a subi de nombreuses évolutions : gameplay, mécanismes inédits, décors, l’ensemble du jeu a entièrement été repensé en 2021 et (comme toutes nos autres salles) nous l’améliorons au quotidien (grosse refonte en 2024 !) car nous pensons que l'escape game est un loisirs en constante évolution.</p>
	    		<h2>Les récompenses reçues</h2>
			Very Bad Night a reçu plusieurs récompenses depuis sa création :
			<ul>
				<li>Award du meilleur scénario</li>
				<li>Prix Traveller's choice Tripadvisor 2022</li>
			</ul>
		  </p>
		</div>
        <div className="theme-other-themes">
          <h3>{formatMessage(messages.discoverOurOtherThemes)}</h3>
          <div className="theme-other-themes-container">
            <Link to="/abattoir/">
              <div className="theme-other-themes-card">
                <div className="theme-other-themes-picture" style={{ backgroundImage: `url(${AbattoirPicture1})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.slaughterhouse)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.slaughterhouseBaseline)}</span>
                </div>
              </div>
            </Link>
            <Link to="/lost-asylum/">
              <div className="theme-other-themes-card">
                <div className="theme-other-themes-picture" style={{ backgroundImage: `url(${LACover})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.lostAsylum)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.laBaseline)}</span>
                </div>
              </div>
            </Link>
            <Link to="/yakuza/">
              <div className="theme-other-themes-card theme-other-themes-card--yakuza">
                <div className="theme-other-themes-picture theme-other-themes-card--yakuza" style={{ backgroundImage: `url(${YakuzaPicture1})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.yakuza)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.yakuzaBaseline)}</span>
                </div>
              </div>
            </Link>
            <Link to="/expedition-maudite/">
              <div className="theme-other-themes-card theme-other-themes-card--tombeau">
                <div className="theme-other-themes-picture theme-other-themes-card--tombeau" style={{ backgroundImage: `url(${TombeauPicture1})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.tombeau)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.tombeauBase)}</span>
                </div>
              </div>
            </Link>
          </div>
        </div>
        <Footer />
        {
          this.state.showPopIn
          ?
           <PopInVBNCustom closePopIn={() => this.togglePopIn()}/>
          : null
        }
      </div>
    )
  }
}

const messages = defineMessages({
  playVideo: {
    id: 'themes.playVideo',
    defaultMessage: 'Lancer la vidéo'
  },
  genre: {
    id: 'themes.genre',
    defaultMessage: 'Genre'
  },
  difficulty: {
    id: 'themes.difficulty',
    defaultMessage: 'Difficulté'
  },
  players: {
    id: 'themes.players',
    defaultMessage: 'Joueurs'
  },
  language: {
    id: 'themes.language',
    defaultMessage: 'Langue'
  },
  genreInfo: {
    id: 'vbn.genre',
    defaultMessage: 'Humour/Potache'
  },
  difficultyInfo: {
    id: 'vbn.difficulty',
    defaultMessage: 'Tous niveaux'
  },
  playersInfo: {
    id: 'vbn.players',
    defaultMessage: 'de 2 à 6 joueurs'
  },
  languageInfo: {
    id: 'vbn.language',
    defaultMessage: 'Français'
  },
  titreh1: {
    id: 'vbn.titreh1',
    defaultMessage: 'Escape game festif à Paris'
  },
  presentationText1: {
    id: 'vbn.presentationText1',
    defaultMessage: 'Après un lendemain de soirée difficile, vous vous réveillez dans un appartement inconnu. A en juger par l’état des lieux la soirée semble avoir été bien arrosée, mais hormis un énorme mal de crâne vous ne vous rappelez plus de grand chose.'
  },
  presentationText2: {
    id: 'vbn.presentationText2',
    defaultMessage: 'll va vite falloir vous remettre les idées en place, car le propriétaire arrive bientôt sur les lieux… Et il n’est pas certain qu’il apprécie particulièrement l’état dans lequel vous avez mis son appartement !'
  },
  disclaimer: {
    id: 'vbn.disclaimer',
    defaultMessage: "Attention, des éléments du jeu peuvent suggérer de l'alcool ou du sexe. Déconseillé aux plus jeunes !"
  },
  gallery: {
    id: 'themes.gallery',
    defaultMessage: 'Galerie'
  },
  testimonalComment: {
    id: 'vbn.testimonalComment',
    defaultMessage: 'Un détour mortel...lement fun ! Aucun temps mort, plusieurs pièces, des énigmes retordes, très différentes et surtout bien trouvées.'
  },
  testimonalAuthor: {
    id: 'vbn.testimonalAuthor',
    defaultMessage: '13ludwigd, Paris, France'
  },
  discoverOurOtherThemes: {
    id: 'themes.discoverOurOtherThemes',
    defaultMessage: 'Découvrez nos autres thèmes escape game Paris :'
  },
  slaughterhouseBaseline: {
    id: 'themesContainer.slaughterhouseBaseline',
    defaultMessage: 'ça va trancher chérie'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: "Very Bad Night"
  },
  lostAsylum: {
    id: 'themes.la',
    defaultMessage: "Lost Asylum"
  },
  laBaseline: {
    id: 'themesContainer.laBaseline',
    defaultMessage: "Echappez-vous avant de devenir fou"
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Yakuza"
  },
  yakuzaBaseline: {
    id: 'themesContainer.yakuzaBaseline',
    defaultMessage: "Une gueule de bois marathon"
  },
  customizationOption: {
    id: 'vbn.customizationOption',
    defaultMessage: "Option de personnalisation"
  },
  customizationOptionText1: {
    id: 'vbn.customizationOptionText1',
    defaultMessage: "Pour 50€ en plus de votre session de jeu."
  },
  customizationOptionText2: {
    id: 'vbn.customizationOptionText2',
    defaultMessage: "Afin de rendre encore plus unique chaque partie, nous proposons la possibilité de personnaliser notre salle Very Bad night."
  },
  learnMore: {
    id: 'vbn.learnMore',
    defaultMessage: "En savoir plus"
  },
  VBNMeta: {
    id: 'themes.VBNMeta',
    defaultMessage: "Very Bad Night"
  },
  tombeau: {
    id: 'themes.tombeau',
    defaultMessage: "L'Expédition Maudite"
  },
  tombeauBaseline: {
    id: 'themesContainer.tombeauBase',
    defaultMessage: "L'aventure à la Indiana Jones"
  },
  tombeauBase: {
    id: 'themesContainer.tombeauBase',
    defaultMessage: "L'aventure à la Indiana Jones"
  },
})

export default injectIntl(VeryBadNight)



// WEBPACK FOOTER //
// ./src/components/VeryBadNight.js